export interface Publish {
  // tslint:disable-next-line:no-any
  [key: string]: any;
  published_at: string;
  // tslint:disable-next-line:no-any
  data: any;
  // AER-1737 / AER-1739: our own classification of a dz_alert as firmware
  // noise rather than a real fault. Deliberately TOP LEVEL and not `data.diag`
  // — `data` stays a faithful mirror of the device payload. Only ever written
  // when true, so an absent flag means "not diagnostic". Redundant against the
  // index signature above, but stated explicitly so the attribute is
  // discoverable and typo-proof at the read sites.
  diag?: boolean;
}

export class _Publish {
  constructor(props?: Publish) {
    for (let key in props) {
      this[key] = props[key];
    }
  }
  // tslint:disable-next-line:no-any
  [key: string]: string | number | undefined | any;
  published_at = new Date().toISOString();
  data = {
    error: 0,
    source: '',
  };
}
